module.exports = {
    loggedInStartTab: 0,
    loggedInStartShortUrl: 1,
};


/** WEBPACK FOOTER **
 ** ./src/constants/target-cohort.js
 **/